import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingService } from '@settings/data-access';
import { DateTime } from 'luxon';

/**
 * Impuro como o `LocaleDateTimePipe` que substituiu — e como o irmão
 * `intlDateTime`. A cultura e o fuso da conta não entram por argumento: são
 * lidos dentro do `transform`, via `FormattingService`. Puro, o Angular via as
 * duas bindings inalteradas (a literal de opções compila para um
 * `pureFunction0` de identidade estável) e nunca reavaliava, deixando as datas
 * já renderizadas congeladas na cultura anterior quando o utilizador a troca em
 * Configurações → Cultura.
 */
@Pipe({
  name: 'intlTime',
  pure: false,
  standalone: true
})
export class IntlTimePipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  /**
   * O valor chega já na hora de parede da conta: a conversão de UTC acontece na
   * fronteira com o backend (`DateInterceptor`, tanto para os campos `*Utc`
   * como para as exceções que o pedido declara em `withUtcDateFields`). Este
   * pipe só formata — reconverter aqui deslocaria o valor pelo offset da conta.
   */
  public transform(value: string | number | Date | DateTime | null | undefined, options?: Intl.DateTimeFormatOptions, locale?: string): string {
    if (!value) return '';
    return this.formattingService.formatTime(value, options, locale);
  }
}